import { createCmsGraphQLClient } from "./client";

export const getCmsGraphQLClient = () => {
    const apiUrl =
        process.env.STRAPI_WEBSITE_API_URL || "http://localhost:1337";
    return createCmsGraphQLClient(apiUrl);
};
